module.exports = __webpack_public_path__ + "static/media/ChronicleDisp-Roman_Web.14f8ac9c.woff2";